import { combineReducers } from "redux";

// Import custom components
import userReducer from "./user";
import menuReducer from "./menu";
import languageReducer from "./language";

const rootReducer = combineReducers({
  user: userReducer,
  menu: menuReducer,
  lang: languageReducer,
});

export default rootReducer;
